import { AbodeAggregateMarketConditions, AloftPrice } from '@aloft/toolkit-shared';
import { Flex } from '@aloft/toolkit-sui';

import { LabelList, Line, LineChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';

import { Typography } from '../../../../summary/components/Typography.tsx';
import { computeTrend } from '../../utils/computeTrend.ts';

export const MedianSalePriceToListPrice = ({ data }: { data: AbodeAggregateMarketConditions }) => {
  const chartData: {
    month: string;
    medianSalePriceToListPrice: number;
  }[] = data.monthlyData
    .filter((item) => !!item.median_sale_price && !!item.median_list_price)
    .map((item) => ({
      month: item.month.substring(0, 7),
      medianSalePriceToListPrice:
        ((AloftPrice.schema.parse(item.median_sale_price)?.toDollarLike() ?? 0) /
          (AloftPrice.schema.parse(item.median_list_price)?.toDollarLike() ?? 1)) *
        100,
    }));
  const maxValue = Math.max(...chartData.map((item) => item.medianSalePriceToListPrice));
  const trendSeries = computeTrend(chartData, 'medianSalePriceToListPrice');
  const trendSeriesColor =
    (trendSeries[trendSeries.length - 1] || { medianSalePriceToListPrice: 0 })
      .medianSalePriceToListPrice >=
    (trendSeries[0] || { medianSalePriceToListPrice: 0 }).medianSalePriceToListPrice
      ? '#00B050'
      : '#FF0000';

  return (
    <Flex
      flexDirection="column"
      className="commentary-chart-container"
      gap={2}
      width="100%"
      maxWidth="1400px"
    >
      <Typography variant="h3">Median Sale Price as % Of List Price</Typography>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={chartData} margin={{ top: 80, right: 50, left: 0, bottom: 0 }}>
          <YAxis domain={[0, maxValue]} tick={false} axisLine={false} />
          <XAxis dataKey="month" interval={0} fontSize={12} tickLine={false} />
          <Line
            type="linear"
            dataKey="medianSalePriceToListPrice"
            stroke="#3455DB"
            strokeWidth={2}
            dot={{ r: 3 }}
          >
            <LabelList
              dataKey="medianSalePriceToListPrice"
              position="top"
              fontSize={12}
              offset={10}
              formatter={(value) => `${Number(value).toFixed(0)}%`}
            />
          </Line>
          <Line
            type="linear"
            data={trendSeries}
            dataKey="medianSalePriceToListPrice"
            stroke={trendSeriesColor}
            strokeWidth={1}
            dot={false}
            strokeDasharray="5 5"
          />
        </LineChart>
      </ResponsiveContainer>
    </Flex>
  );
};
